import { ExternalLink } from 'lucide-react';
import { BANNIERE_TIPEE } from '../format';
import { queNom } from './textesDemande';

interface Props {
  tipeeUrl: string;
  confirme: boolean;
  /** Le lien Tipee a été ouvert dans cette visite : le bouton dit « C'est fait » plutôt que « C'est déjà fait ». */
  ouvert: boolean;
  onOuvert: () => void;
  onConfirmer: (v: boolean) => void;
  /** Nom de la personne absente quand ce n'est pas la personne connectée (gestion) ; null = « vous » ; '' = la gestion ne l'a pas encore choisie. */
  nomAbsent: string | null;
}

/**
 * Rappel Tipee, actionnable et bloquant : « Envoyer » reste inactif tant que ce bloc n'a pas de réponse. Les deux options sont proposées d'emblée, côte à
 * côte (si c'est déjà fait avant d'ouvrir la page, on confirme directement). Pas d'échappatoire « plus tard ».
 */
export function CarteTipee({ tipeeUrl, confirme, ouvert, onOuvert, onConfirmer, nomAbsent }: Props) {
  if (confirme) {
    return (
      <div className="nd-tipee is-ok">
        <p className="nd-ok"><span aria-hidden="true">✓ </span>{nomAbsent !== null ? 'Demande de congé Tipee vérifiée.' : 'Demande de congé Tipee confirmée.'}
          <button type="button" className="nd-lien" data-fid="tipeeAnnuler" aria-label="Annuler la confirmation Tipee" onClick={() => onConfirmer(false)}>Annuler</button>
        </p>
      </div>
    );
  }
  return (
    <div className="nd-tipee">
      <p>{nomAbsent === null ? BANNIERE_TIPEE : nomAbsent ? `Vérifiez ${queNom(nomAbsent)} a bien fait sa demande de congé dans Tipee.` : 'Vérifiez dans Tipee que la demande de congé a bien été faite.'}</p>
      <div className="nd-ligne-boutons">
        {tipeeUrl && (
          <a className="btn btn-sm" href={tipeeUrl} target="_blank" rel="noreferrer noopener" data-fid="tipeeOuvrir" onClick={onOuvert}>
            Ouvrir Tipee <ExternalLink className="icon-sm" aria-hidden="true" />
          </a>
        )}
        <button type="button" className="btn btn-sm btn-accent" data-fid="tipeeFait" onClick={() => onConfirmer(true)}>
          {nomAbsent !== null ? "C'est vérifié" : ouvert ? "C'est fait" : "C'est déjà fait"}
        </button>
      </div>
      {ouvert && <p className="nd-aide">Tipee s'ouvre dans un nouvel onglet. Revenez ici une fois la demande de congé faite.</p>}
    </div>
  );
}
